import { reduxForm, Field } from 'redux-form';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Card, CardBody, Col, Container, Form, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import InputAuth from '../common/inputAuth';
import { gerarCodigoMfa, validaCodigoMfa } from '../../actions/mfaActions';
import { getIntegracaoSistema, login } from '../../actions/authActions';
import { toastr } from 'react-redux-toastr'

const MfaSmartForm = ({
    IdUsuario,
    Email,
    Usuario,
    dataExpiracao,
    tempoEnvio,
    bgColorContainer,
    boxTitle,
    gColorBoxTitle,
    textColorBoxTitle,
    handleSubmit,
    goBack,
    prelogin
}) => {
    const targetDate = new Date(dataExpiracao).getTime();
    const [timeLeft, setTimeLeft] = useState(Math.floor((targetDate - Date.now()) / 1000))
    const [mfaCodigo, setMfaCodigo] = useState('');
    const dispatch = useDispatch();
    const timerRef = useRef(null);
    useEffect(() => {
        startCountdown(); // inicia o countdown ao montar o componente
        return () => clearInterval(timerRef.current); // limpa ao desmontar
    }, []);
    // Função para iniciar o countdown
    const startCountdown = () => {
        if (timerRef.current) clearInterval(timerRef.current); // Limpa timer anterior
        timerRef.current = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(timerRef.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };
    const formatTime = (time) => {
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const validarCodigoMfa = async () => {
        try {
            //console.log('PASSAGEM -------- DEPOIS DISPATH1')
            const config = await getIntegracaoSistema();
            //console.log('PASSAGEM -------- getIntegracaoSistema')
            const body = {
                codigo: mfaCodigo,
                IdUsuario: IdUsuario
            }
            //console.log('PASSAGEM -------- VALIDAR CODIGOMFA: ', body, config.data.obj)
            const ret = await validaCodigoMfa(body, config.data.obj);
            //console.log('PASSAGEM -------- DISPATH 0', prelogin);
            // dispatch(authActions.userFetched(prelogin));
            if (ret.status == 200) {
                dispatch({
                    type: 'USER_FETCHED',
                    payload: prelogin
                })
                goBack()
            }
            //console.log('PASSAGEM -------- DISPATH 1', prelogin);
        } catch (error) {
            //console.log('PASSAGEM -------- ERRO', error);
            toastr.error('Código Inválido !!!')
        }
    };

    const reenvioCodigoMfa = async () => {
        try {
            const config = await getIntegracaoSistema();
            const body = {
                IdUsuario,
                Usuario,
                Email
            }
            const reenvio = await gerarCodigoMfa(body, config.data.obj);
            const targetDates = new Date(reenvio.data_expiracao).getTime();
            setTimeLeft(Math.floor((targetDates - Date.now()) / 1000));
            startCountdown(); // reinicia o countdown com o novo tempo
        } catch (error) {
            //console.log('DISPATH ERRO', error);
            toastr.error('Erro ao validar o código MFA')
        }
    };
    return (
        <div className="app flex-row align-items-center">
            <Container>
                <Row className="justify-content-center">
                    <Col md="6">
                        <Card className="mx-4" style={{
                            backgroundColor: bgColorContainer || '',
                        }}>
                            {boxTitle && <Card md="8" style={{
                                backgroundColor: gColorBoxTitle,
                                borderRadius: '0.25rem 0.25rem 0 0',
                                borderStyle: 'none',
                                margin: '0',
                                padding: '12px 0 0 24px',
                            }}>
                                <h1 style={{ color: textColorBoxTitle, fontSize: '25px' }}>{boxTitle}</h1>
                            </Card>}
                            <CardBody className="p-4">
                                <Form className="mp-0 w-100">
                                    <h2 style={{
                                        fontSize: '24px',
                                        textAlign: 'center',
                                        color: 'black'
                                    }}>Autenticação de 2 fatores </h2>
                                    <h3 style={{
                                        fontSize: '18px',
                                        textAlign: 'center',
                                        color: '#515a5a',
                                        marginBottom: '20px'
                                    }}>Olá, enviamos o código de validação para </h3>
                                    <h4 style={{
                                        fontSize: '16px',
                                        textAlign: 'center',
                                        color: 'black',
                                        marginBottom: '20px'
                                    }}>{Email}</h4>

                                    <InputGroup className="mb-4">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="icon-lock"></i>
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Field
                                            component={InputAuth}
                                            name="mfaCodigo"
                                            type="number"
                                            id="mfaCodigo"
                                            icon='lock'
                                            placeholder="Digite código enviado via e-mail"
                                            value={mfaCodigo}
                                            onChange={(e) => setMfaCodigo(e.target.value)}
                                        />
                                    </InputGroup>

                                    <p
                                        style={{
                                            fontSize: '24px',
                                            textAlign: 'center',
                                            color: '#007bff',
                                            marginBottom: '30px',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        Validade Token <b>{formatTime(timeLeft)}</b>
                                    </p>

                                    <div className="d-flex justify-content-between" style={{ padding: '0px', width: '100%' }}>
                                        <Button
                                            color="primary"
                                            style={{
                                                backgroundColor: '#007bff',
                                                borderColor: '#007bff',
                                                padding: '10px 15px',
                                                borderRadius: '5px',
                                                fontSize: '16px',
                                                fontWeight: 'bold',
                                                flex: '1',
                                                marginRight: '10px',
                                            }}
                                            onClick={validarCodigoMfa}
                                        >
                                            Enviar
                                        </Button>
                                        <Button
                                            color="secondary"
                                            disabled={timeLeft > 0} // Botão habilitado apenas quando o tempo for 0
                                            style={{
                                                backgroundColor: timeLeft > 0 ? '#d6d6d6' : '#6c757d', // Cinza quando desabilitado
                                                borderColor: timeLeft > 0 ? '#d6d6d6' : '#6c757d',
                                                padding: '10px 0px',
                                                borderRadius: '5px',
                                                fontSize: '16px',
                                                fontWeight: 'bold',
                                                flex: '1',
                                            }}
                                            onClick={reenvioCodigoMfa}
                                        >
                                            Enviar Novo Token
                                        </Button>
                                    </div>
                                    <div class="d-flex justify-content-between" style={{ marginTop: '15px' }}>
                                        <Button
                                            type="button"
                                            color="secundary-smart"
                                            style={{ padding: '15px' }}
                                            block
                                            onClick={goBack}
                                        >Voltar</Button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default reduxForm({
    form: 'mfaSmart'
})(MfaSmartForm);
